import { render, staticRenderFns } from "./ships-confirm-edit.vue?vue&type=template&id=2fbf3e46&scoped=true&"
import script from "./ships-confirm-edit.vue?vue&type=script&lang=js&"
export * from "./ships-confirm-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf3e46",
  null
  
)

export default component.exports